<template>
  <el-drawer
    title="预览"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="600px"
    custom-class="preview-drawer"
    @close="$emit('close')"
  >
    <div class="content">
      <el-scrollbar :native="false">
        <div class="detail-box" v-loading="loading">
          <img :src="data.boutiqueUrl" class="pic" />
          <div class="detail-content">
            <div class="name-box">
              <div class="name">{{data.boutiqueName}}</div>
              <div class="name-eg">{{data.boutiqueEnglishName}}</div>
            </div>
            <div class="middle-box">
              <div class="cell-name">详情描述</div>
              <div
                class="cell-content"
              >{{data.boutiqueDetail? data.boutiqueDetail : '暂无介绍' }}</div>
            </div>
            <div class="bottom-box">
              <div class="cell-name">店铺地址</div>
              <div
                class="shop-box"
                v-for="(item,index) in shopList"
                :key="index"
              >
                <span>{{item.shopName}}</span>
                <span decode="true" class="look-detail">查看详情 &gt;</span>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </el-drawer>
</template>

<script>
import { getBoutique, getShopList } from '@/api/goods';

export default {
  name: 'cigarPage',
  data() {
    return {
      data: {},
      shopList: [],
      drawerVisible: false,
      loading: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    visible(value) {
      this.drawerVisible = value;
    },
    selectId(value) {
      this.handleShow(value);
    },
  },
  methods: {
    getBoutique(id) {
      return getBoutique(id).then((res) => {
        if (res.success) {
          this.data = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getShopList() {
      return getShopList().then((res) => {
        if (res.success) {
          this.shopList = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async handleShow(id) {
      this.loading = true;
      await this.getBoutique(id).catch(() => {});
      await this.getShopList().catch(() => {});
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~assets/css/h5.styl";
.star
  width 20px
  height 20px
.cell
  display flex
  margin-top 10px
.cell-block
  flex 1
</style>
